<script lang="ts">
    import { createEventDispatcher, onMount, tick } from "svelte"
    import { tooltip } from "../../helper"

    import { getAddress, getPriceCalculationByDealers } from "../../api"
    import { mdiDomain, mdiAccount, mdiClose } from "@mdi/js"
    import Icon from "./Icon.svelte"
    import Select from "svelte-select"
    import { formType, login } from "../../store"
    import { landSelections } from "../../config"
    import { emptyAddressObj, emptyDeliveryAddressObj } from "../../helperObjects"
    import Radiobutton from "./Radiobutton.svelte"
    import PricecalcFields from "../routes/pricecalc/PricecalcFields.svelte"
    import { _ } from "svelte-i18n"
    import { normalizeVat } from "../../../../api/hooks/config-client"

    export let formData: Address
    export let formElement: HTMLFormElement
    export let submitAction: any = null
    export let headline = null

    export let readonly = false
    export let typeSelection = true
    export let cartId: string
    export let mustBePerson = false
    export let disableCompanyFields = false
    export let showPriceCalcSelect = false
    export let hide = false
    export let onlyDeliveryFields = false
    export let onlyBillingFields = false
    export let showPaymentTerms = false
    export let saveManually = false
    export let inCart = false
    export let noMandatoryMarkers = false
    export let showTelephoneNumber = false
    let selectedSalutationItem = {
        label: formData?.person?.salutation || "",
        value: formData?.person?.salutation || "",
    }

    const dispatch = createEventDispatcher()
    let actionButton: HTMLButtonElement
    let selectedSalutationItemDeliveryAddress = {
        label: formData?.deliveryAddress?.salutation || "",
        value: formData?.deliveryAddress?.salutation || "",
    }

    const emptyAddress = JSON.parse(JSON.stringify(emptyAddressObj))
    const emptyDeliveryAddress = JSON.parse(JSON.stringify(emptyDeliveryAddressObj))
    $: {
        if (formData.company == undefined) {
            formData.company = {
                name: "",
                vatId: "",
                firstname: "",
                lastname: "",
            }
        }
        if (formData.person == undefined) {
            formData.person = {
                salutation: "",
                firstname: "",
                lastname: "",
                parentCompany: "",
            }
        }
        if (formData.location == undefined) {
            formData.location = {
                street: "",
                houseNumber: "",
                supplement: "",
                postcode: "",
                city: "",
                country: "",
            }
        }
        if (formData.contact == undefined) {
            formData.contact = {
                phone: "",
                fax: "",
                email: "",
                website: "",
            }
        }

        const normalizedVat = normalizeVat(formData.vat, null)
        if (normalizedVat === null) {
            formData.vat = 19
        } else if (normalizedVat !== formData.vat) {
            formData.vat = normalizedVat
        }
    }
    $: if (!selectedSalutationItem)
        selectedSalutationItem = {
            value: formData?.person?.salutation || null,
            label: formData?.person?.salutation || "",
        }
    $: if (!selectedSalutationItemDeliveryAddress)
        selectedSalutationItemDeliveryAddress = {
            value: formData?.deliveryAddress?.salutation || "",
            label: formData?.deliveryAddress?.salutation || "",
        }
    let salutationItems = [
        {
            value: "Herr",
            label: $_("general.mr"),
        },
        {
            value: "Frau",
            label: $_("general.mrs"),
        },
        {
            value: "Sonstige",
            label: $_("general.others"),
        },
    ]
    let landSelectionValue = {
        value: null as string | null,
        label: "",
    }
    let landSelectionValueDeliveryAddress = {
        value: "",
        label: "",
    }
    export const resetForm = () => {
        // @ts-ignore
        formData = JSON.parse(JSON.stringify(emptyAddress))
        formData.deliveryAddress = JSON.parse(JSON.stringify(emptyDeliveryAddressObj))
        selectedSalutationItem = null
        selectedSalutationItemDeliveryAddress = null
        landSelectionValue = null
        landSelectionValueDeliveryAddress = null
    }

    function updateForm(form = formData) {
        if (cooldown && !submitAction) {
            dispatch("submit", { action: "update-cart", form: form })
        }
    }

    const updateCompanyOrSupplementField = (event: Event) => {
        const target = event.currentTarget as HTMLInputElement | null
        const value = target?.value || ""

        if (formData.type === "person" && disableCompanyFields) {
            formData.company.name = value
            return
        }

        formData.location.supplement = value
    }

    const fillParentCompany = (company: Address) => {
        if (!formData.contact) formData.contact = {}
        // @ts-ignore
        if (!formData.company) formData.company = {}
        if (!formData.location) formData.location = {}

        // Fill form fields with parent company location data
        formData.location.street = company?.location?.street || ""
        formData.location.houseNumber = company?.location?.houseNumber || ""
        formData.location.supplement = company?.location?.supplement || ""
        formData.location.postcode = company?.location?.postcode || ""
        formData.location.city = company?.location?.city || ""
        formData.location.country = company?.location?.country || ""

        formData.company.name = company?.company?.name
        formData.company.vatId = company?.company?.vatId
        formData.vat = normalizeVat(company?.vat, null)
        formData.company.firstname = company?.company?.firstname
        formData.company.lastname = company?.company?.lastname
        formData.customerNumber = company?.customerNumber
        if (company?.deliveryAddress) {
            formData.deliveryAddress = JSON.parse(JSON.stringify(company?.deliveryAddress))
            if (inCart) {
                formData.deliveryAddress.name3 = (
                    formData.person?.lastname +
                    (formData.person?.firstname ? ", " : "") +
                    formData.person?.firstname
                ).substring(0, 30)
                formData.deliveryAddress.name2 = formData?.location?.supplement
            } else {
                formData.deliveryAddress.name2 = formData?.person?.firstname
                formData.deliveryAddress.name3 = formData?.person?.lastname
            }
            formData.deliveryAddress.salutation = formData?.person?.salutation
            selectedSalutationItemDeliveryAddress = {
                label: formData?.deliveryAddress?.salutation || "",
                value: formData?.deliveryAddress?.salutation || null,
            }
        } else {
            if (inCart) {
                formData.deliveryAddress = {
                    salutation: formData?.person?.salutation || "",
                    name1: formData?.company?.name || "",
                    name2: formData?.location?.supplement || "",
                    name3:
                        ((formData?.person?.lastname || "") + " " + (formData?.person?.firstname || "")).substring(
                            0,
                            30
                        ) || "",
                    street: formData?.location?.street
                        ? `${formData.location.street} ${formData.location.houseNumber}`
                        : "",
                    postcode: formData?.location?.postcode || "",
                    city: formData?.location?.city || "",
                    country: formData?.location?.country || "",
                    phone: formData?.contact?.phone || "",
                    email: formData?.contact?.email || "",
                    fax: formData?.contact?.fax || "",
                }
            } else {
                formData.deliveryAddress = null
            }
        }
        // Set land selection value
        landSelectionValue = {
            value: formData.location.country || "",
            label: landSelections.filter((l) => l.value === formData?.location?.country)?.[0]?.label || "",
        }
    }

    export const updateFormDataByAddress = async (address: Address) => {
        resetForm()
        formData.id = address?.id || null
        formData.type = address?.type || "person"
        if (!formData.location) formData.location = {}
        // Assign location fields
        Object.assign(formData.location, {
            street: address?.location?.street || null,
            houseNumber: address?.location?.houseNumber || null,
            supplement: address?.location?.supplement || null,
            postcode: address?.location?.postcode || null,
            city: address?.location?.city || null,
            country: address?.location?.country || null,
        })

        //@ts-ignore Assign person fields
        if (!formData.person) formData.person = {}
        Object.assign(formData.person, {
            salutation: address?.person?.salutation || null,
            firstname: address?.person?.firstname || null,
            lastname: address?.person?.lastname || null,
            parentCompany: address?.person?.parentCompany || null,
        })

        selectedSalutationItem = { label: formData.person.salutation || "", value: formData.person.salutation || null }

        // Assign contact fields @ts-ignore
        if (!formData.contact) formData.contact = {}
        Object.assign(formData.contact, {
            phone: address?.contact?.phone || null,
            fax: address?.contact?.fax || null,
            email: address?.contact?.email || null,
            website: address?.contact?.website || null,
        })

        // @ts-ignore Assign company fields
        if (!formData.company) formData.company = {}
        Object.assign(formData.company, {
            name: address?.company?.name || null,
            vatId: address?.company?.vatId || null,
            firstname: address?.company?.firstname || null,
            lastname: address?.company?.lastname || null,
            paymentTerms: address?.company?.paymentTerms || null,
        })

        formData.customerNumber = address?.customerNumber || null
        formData.vat = normalizeVat(address?.vat, null)
        formData.priceCalculation = address?.priceCalculation || null
        formData.notModifyablePCalc = address?.notModifyablePCalc || false
        landSelectionValue = {
            value: address?.location?.country,
            label: landSelections?.filter((l) => l?.value === address?.location?.country)[0]?.label,
        }
        formData.deliveryAddress = address?.deliveryAddress
        selectedSalutationItemDeliveryAddress = {
            label: formData?.deliveryAddress?.salutation || "",
            value: formData?.deliveryAddress?.salutation || "",
        }
        //  @ts-ignore
        if (!formData.deliveryAddress) formData.deliveryAddress = {}
        if (formData.type == "person" && address?.person?.parentCompany) {
            let res = await getAddress(address?.person?.parentCompany)
            let parentCompany = res.data
            fillParentCompany(parentCompany)
        }
        // Hier stand ein `else if` mit exakt derselben Bedingung wie das `if`
        // darüber. Es war nie erreichbar: fillParentCompany verändert weder
        // formData.type noch address.person.parentCompany, die Bedingung ist
        // beim else if also genauso false wie zuvor. Sein Inhalt (name2 aus
        // location.supplement, name3 aus Vor-/Nachname) wird von
        // fillParentCompany in beiden Zweigen bereits gesetzt.

        if (formData.deliveryAddress && Object.keys(formData.deliveryAddress).length == 0) {
            delete formData.deliveryAddress
        }
        if (!formData.deliveryAddress?.name1 && !formData.deliveryAddress?.name2 && !formData.deliveryAddress?.name3) {
            // @ts-ignore
            formData.deliveryAddress = {}
            formData.deliveryAddress.city = formData.location?.city || ""
            formData.deliveryAddress.country = formData.location?.country || ""
            formData.deliveryAddress.postcode = formData.location?.postcode || ""

            formData.deliveryAddress.street =
                (formData.location?.street || "") +
                (formData.location?.houseNumber ? " " : "") +
                (formData.location?.houseNumber || "")
            formData.deliveryAddress.name1 = formData.company?.name || ""
            if (formData.type == "company") {
                formData.deliveryAddress.name2 = formData.location?.supplement || ""
            } else if (inCart) {
                formData.deliveryAddress.name2 = formData.location?.supplement || ""
                formData.deliveryAddress.name3 = (
                    (formData.person?.lastname || "") +
                    (formData.person?.firstname ? ", " : "") +
                    (formData.person?.firstname || "")
                ).substring(0, 30)
            } else {
                formData.deliveryAddress.name2 = formData.person?.firstname || ""
                formData.deliveryAddress.name3 = formData.person?.lastname || ""
            }

            formData.deliveryAddress.salutation = formData.person?.salutation || ""
            selectedSalutationItemDeliveryAddress = {
                label: formData.deliveryAddress?.salutation || "",
                value: formData.deliveryAddress?.salutation || null,
            }
            formData.deliveryAddress.phone = formData.contact?.phone || ""
            formData.deliveryAddress.fax = formData.contact?.fax || ""
            formData.deliveryAddress.email = formData.contact?.email || ""
        }
    }

    const submit = (_: any) => {
        dispatch("submit", { action: submitAction, form: formData })
        submitAction = null
    }

    const clickOnActionButton = async () => {
        await tick()
        actionButton.click()
    }

    $: if (submitAction) {
        clickOnActionButton()
    }

    // Initial
    $: if (formData?.location?.country && !landSelectionValue?.value) {
        // Set land selection value
        landSelectionValue = {
            value: formData?.location?.country || "",
            label: landSelections.filter((l) => l.value === formData?.location?.country)[0]?.label || "",
        }
    } else if (landSelectionValue == null) {
        landSelectionValue = {
            label: "",
            value: "",
        }
    }

    $: if (formData?.deliveryAddress?.country && !landSelectionValueDeliveryAddress?.value) {
        // Set land selection value
        landSelectionValueDeliveryAddress = {
            value: formData?.deliveryAddress?.country || "",
            label: landSelections.filter((l) => l.value === formData?.deliveryAddress?.country)[0]?.label || "",
        }
    } else if (landSelectionValueDeliveryAddress == null) {
        landSelectionValueDeliveryAddress = {
            label: "",
            value: "",
        }
    }

    $: {
        setCooldown()
        if (!saveManually) {
            updateForm(formData)
        }
    }

    let cooldown = false
    function setCooldown() {
        setTimeout(() => {
            cooldown = true
        }, 500)
    }

    if ($formType[cartId] && formData) {
        formData.type = $formType[cartId]
    }

    let priceCalcValue = {
        value: null as string | null,
        label: "",
    }
    let priceGroupItems: { value: string | number; label: string }[] = []
    const loadAllPricegroups = async () => {
        const response = await getPriceCalculationByDealers($login?.account?.ident?.dealerNumber)
        priceGroupItems = []
        response.data.forEach((p) => {
            if (typeof p.groupName !== "string") return
            if (p.id == formData?.priceCalculation) {
                priceCalcValue = {
                    value: p?.id,
                    label: `${p.groupName || $_("priceCalculation.globalPricegroup")} - ${$_(
                        "priceCalculation.dealerNr"
                    )}: ${p.dealerNumber}`,
                }
            }
            priceGroupItems.push({
                value: p?.id,
                label: `${p.groupName || $_("priceCalculation.globalPricegroup")} - ${$_(
                    "priceCalculation.dealerNr"
                )}: ${p.dealerNumber}`,
            })
        })
        if (formData.priceCalculation == "manual") {
            priceCalcValue = {
                value: "manual",
                label: $_("priceCalculation.manualInput"),
            }
        }
        priceGroupItems.push({
            value: "manual",
            label: $_("priceCalculation.manualInput"),
        })
    }
    loadAllPricegroups()
    onMount(() => {
        setTimeout(() => {
            let el = document.getElementsByClassName("focused")[0]
            if (el) {
                el.classList.remove("focused")
                el.classList.remove("list-open")
            }
        }, 500)
    })

    function setPCalc() {
        if (priceCalcValue?.value && formData?.priceCalculation != priceCalcValue?.value) {
            formData.priceCalculation = priceCalcValue?.value
        }
    }
    $: if (priceCalcValue?.value) {
        setPCalc()
    }
    $: {
        if (selectedSalutationItem == null || (!selectedSalutationItem.value && formData?.person?.salutation)) {
            selectedSalutationItem = {
                label: formData?.person?.salutation || "",
                value: formData?.person?.salutation || null,
            }
        }
        if (
            selectedSalutationItemDeliveryAddress == null ||
            (!selectedSalutationItemDeliveryAddress.value && formData?.deliveryAddress?.salutation)
        ) {
            selectedSalutationItemDeliveryAddress = {
                label: formData?.deliveryAddress?.salutation || "",
                value: formData?.deliveryAddress?.salutation || "",
            }
        }
    }
    onMount(() => {
        dispatch("mounted")
    })
</script>

{#if formData}
    <form class="address-form" bind:this="{formElement}" on:submit|preventDefault="{submit}">
        <button type="submit" name="{submitAction}" bind:this="{actionButton}" class="hidden">{submitAction}</button>
        {#if !hide}
            <div>
                {#if !onlyDeliveryFields}
                    <section>
                        {#if headline}
                            <div class="section-title">{headline}</div>
                        {/if}

                        {#if typeSelection && !onlyDeliveryFields && !onlyBillingFields}
                            <div class="row tabs">
                                {#if formData.type == "person"}
                                    <div
                                        class="col-md-{formData.id || mustBePerson
                                            ? '12 no-padding'
                                            : '6 no-padding-left'}"
                                    >
                                        <!-- svelte-ignore a11y-no-static-element-interactions -->
                                        <div
                                            class="tab"
                                            class:active="{formData.type === 'person'}"
                                            data-cy="person"
                                            on:click="{() => {
                                                formData.type = 'person'
                                                $formType[cartId] = 'person'
                                            }}"
                                            on:keydown
                                        >
                                            <Icon path="{mdiAccount}" size="24px" />
                                            {$_("address.contactPerson")}
                                        </div>
                                    </div>
                                {/if}
                                {#if (formData.type == "company" || !formData.id) && !mustBePerson}
                                    <div class="col-md-{!mustBePerson ? '12 no-padding' : '6 no-padding-right'}  ">
                                        <!-- svelte-ignore a11y-no-static-element-interactions -->
                                        <div
                                            class="tab"
                                            class:active="{formData.type === 'company'}"
                                            data-cy="company"
                                            on:click="{() => {
                                                formData.type = 'company'
                                                $formType[cartId] = 'company'
                                            }}"
                                            on:keydown
                                        >
                                            <Icon path="{mdiDomain}" size="24px" />{$_("address.company")}
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        {/if}

                        {#if formData.type === "person"}
                            <div class="row">
                                {#if !onlyBillingFields}
                                    <div class="col-sm-12 col-md-4">
                                        <div
                                            class="inputholder haslabel"
                                            data-cy="salutation"
                                            class:readonly="{readonly ||
                                                (onlyDeliveryFields && !!formData.company.name)}"
                                        >
                                            <label for="">
                                                {$_("address.salutation")}{noMandatoryMarkers ? "" : "*"}</label
                                            >

                                            <Select
                                                clearable="{selectedSalutationItem.value ? true : false}"
                                                showChevron
                                                required="{(!readonly && !onlyDeliveryFields) ||
                                                    (!readonly && onlyDeliveryFields && !formData.company.name)}"
                                                placeholder=""
                                                items="{salutationItems}"
                                                focused="{false}"
                                                bind:value="{selectedSalutationItem}"
                                                bind:disabled="{readonly}"
                                                on:change="{(e) => {
                                                    formData.person.salutation = e.detail.value
                                                }}"
                                                on:clear="{() => {
                                                    formData.person.salutation = null
                                                    selectedSalutationItem = {
                                                        value: null,
                                                        label: '',
                                                    }
                                                }}"
                                            />
                                        </div>
                                    </div>
                                {/if}
                                <div class="col-sm-6 col-md-{onlyBillingFields ? 6 : 4}">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.firstName")}{noMandatoryMarkers ? "" : "*"}</label>
                                        <input
                                            required="{(!readonly && !onlyDeliveryFields) ||
                                                (!readonly && onlyDeliveryFields && !formData.company.name)}"
                                            type="text"
                                            id="firstname-{cartId}"
                                            data-cy="firstname"
                                            placeholder=""
                                            maxlength="{30}"
                                            value="{formData?.person?.firstname || ''}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.person.firstname = e.target.value
                                            }}"
                                            disabled="{(onlyDeliveryFields && !!formData.company.name) || readonly}"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-6 col-md-{onlyBillingFields ? 6 : 4}">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.lastName")}{noMandatoryMarkers ? "" : "*"}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="lastname-{cartId}"
                                            data-cy="lastname"
                                            value="{formData?.person?.lastname || ''}"
                                            maxlength="{30}"
                                            required="{(!readonly && !onlyDeliveryFields) ||
                                                (!readonly && onlyDeliveryFields && !formData.company.name)}"
                                            disabled="{(onlyDeliveryFields && !!formData.company.name) || readonly}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.person.lastname = e.target.value
                                            }}"
                                        />
                                    </div>
                                </div>
                            </div>
                        {/if}

                        <div class="row">
                            {#if !onlyDeliveryFields && !onlyBillingFields}
                                <div class="{formData.type === 'person' ? 'col-md-12' : 'col-md-4 col-sm-12'}">
                                    {#if formData.type !== "person"}
                                        <div class="inputholder haslabel" class:readonly>
                                            <label for=""
                                                >{$_("address.companyName")}{noMandatoryMarkers ? "" : "*"}</label
                                            >
                                            <input
                                                type="text"
                                                placeholder=""
                                                id="companyname-{cartId}"
                                                maxlength="{30}"
                                                data-cy="companyname"
                                                value="{formData?.company?.name || ''}"
                                                on:blur="{(e) => {
                                                    // @ts-ignore
                                                    formData.company.name = e.target.value
                                                }}"
                                                required="{!readonly}"
                                            />
                                        </div>
                                    {/if}
                                </div>
                                <div class="col-md-{formData.type == 'company' ? 4 : 12} col-sm-12">
                                    <div
                                        class="inputholder haslabel"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for=""
                                            >{formData.type === "person" && disableCompanyFields
                                                ? $_("address.companyName")
                                                : $_("address.company2OrAdditionalAddress")}</label
                                        >
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="supplement-{cartId}"
                                            data-cy="addresssup"
                                            value="{formData.type === 'person' && disableCompanyFields
                                                ? formData?.company?.name || ''
                                                : formData?.location?.supplement || ''}"
                                            on:blur="{updateCompanyOrSupplementField}"
                                        />
                                    </div>
                                </div>

                                {#if formData.type === "company"}
                                    <div class="col-md-2 col-sm-6">
                                        <div class="inputholder haslabel" class:readonly>
                                            <label for=""> {$_("address.vatId")}</label>
                                            <input
                                                type="text"
                                                placeholder=""
                                                data-cy="vatId"
                                                id="vatid-{cartId}"
                                                value="{formData?.company?.vatId || ''}"
                                                on:blur="{(e) => {
                                                    // @ts-ignore
                                                    formData.company.vatId = e.target.value
                                                }}"
                                            />
                                        </div>
                                    </div>
                                {/if}
                            {:else}
                                <div
                                    class="col-md-{(formData.type === 'company' || onlyBillingFields) &&
                                    !onlyDeliveryFields
                                        ? 4
                                        : 6}"
                                >
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.companyName")}{noMandatoryMarkers ? "" : "*"}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="companyname-{cartId}"
                                            maxlength="{30}"
                                            data-cy="companyname"
                                            value="{formData?.company?.name || ''}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.company.name = e.target.value
                                            }}"
                                            required="{!readonly && onlyDeliveryFields && !!formData.person.firstname}"
                                            disabled="{onlyDeliveryFields &&
                                                (!!formData.person.firstname ||
                                                    !!formData.person.lastname ||
                                                    !!formData.person.salutation)}"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-md-{(formData.type === 'company' || onlyBillingFields) &&
                                    !onlyDeliveryFields
                                        ? 4
                                        : 6} col-sm-12"
                                >
                                    <div
                                        class="inputholder haslabel"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for="">{$_("address.company2OrAdditionalAddress")}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="supplement-{cartId}"
                                            data-cy="addresssup"
                                            value="{formData?.location?.supplement || ''}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.location.supplement = e.target.value
                                            }}"
                                        />
                                    </div>
                                </div>
                            {/if}

                            {#if (formData.type === "company" || onlyBillingFields) && !onlyDeliveryFields}
                                <div class="col-md-{formData.type == 'company' && !onlyBillingFields ? 2 : 4} col-sm-6">
                                    <div
                                        class="inputholder haslabel"
                                        class:readonly
                                        use:tooltip="{{
                                            content: $_('address.noChangeToGlobalTaxRate'),
                                        }}"
                                    >
                                        <label for=""> {$_("address.vat")}</label>
                                        <input
                                            type="text"
                                            inputmode="decimal"
                                            id="vat-{cartId}"
                                            data-cy="vat"
                                            value="{formData.vat}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.vat = normalizeVat(e.target.value)
                                            }}"
                                        />
                                    </div>
                                </div>
                            {/if}
                        </div>
                        <div class="row">
                            <div class="col-md-{onlyDeliveryFields ? '12' : '6'}">
                                <div
                                    class="inputholder haslabel"
                                    class:readonly="{readonly ? true : false || disableCompanyFields}"
                                >
                                    <label for=""> {$_("address.street")}{noMandatoryMarkers ? "" : "*"}</label>
                                    <input
                                        type="text"
                                        placeholder=""
                                        id="street-{cartId}"
                                        data-cy="street"
                                        value="{formData?.location?.street || ''}"
                                        maxlength="{28}"
                                        on:blur="{(e) => {
                                            // @ts-ignore
                                            formData.location.street = e.target.value
                                        }}"
                                        required="{!readonly}"
                                    />
                                </div>
                            </div>
                            {#if !onlyDeliveryFields}
                                <div class="col-md-6 col-sm-6">
                                    <div
                                        class="inputholder haslabel"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for="">
                                            {$_("address.houseNumber")}{noMandatoryMarkers ? "" : "*"}</label
                                        >
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="housenumber-{cartId}"
                                            data-cy="housenumber"
                                            maxlength="{30}"
                                            value="{formData?.location?.houseNumber || ''}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.location.houseNumber = e.target.value
                                                formData = formData
                                            }}"
                                            required="{!readonly && !onlyDeliveryFields && !disableCompanyFields}"
                                        />
                                    </div>
                                </div>
                            {/if}
                        </div>
                        <div class="row">
                            <div class="col-sm-6 col-md-{onlyBillingFields ? 6 : 4}">
                                <div
                                    class="inputholder haslabel"
                                    class:readonly="{readonly ? true : false || disableCompanyFields}"
                                >
                                    <label for="">{$_("address.postalCode")}{noMandatoryMarkers ? "" : "*"}</label>
                                    <input
                                        type="text"
                                        placeholder=""
                                        id="postcode-{cartId}"
                                        data-cy="postcode"
                                        value="{formData?.location?.postcode || ''}"
                                        maxlength="{10}"
                                        on:blur="{(e) => {
                                            // @ts-ignore
                                            formData.location.postcode = e.target.value
                                        }}"
                                        required="{!readonly}"
                                    />
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-{onlyBillingFields ? 6 : 4}">
                                <div
                                    class="inputholder haslabel"
                                    class:readonly="{readonly ? true : false || disableCompanyFields}"
                                >
                                    <label for=""> {$_("address.city")}{noMandatoryMarkers ? "" : "*"}</label>
                                    <input
                                        type="text"
                                        placeholder=""
                                        id="city-{cartId}"
                                        data-cy="city"
                                        value="{formData?.location?.city || ''}"
                                        maxlength="{30}"
                                        on:blur="{(e) => {
                                            // @ts-ignore
                                            formData.location.city = e.target.value
                                        }}"
                                        required="{!readonly}"
                                    />
                                </div>
                            </div>
                            {#if !onlyBillingFields}
                                <div class="col-sm-12 col-md-4">
                                    <div
                                        class="inputholder haslabel"
                                        data-cy="country"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for=""> {$_("address.country")}</label>
                                        <Select
                                            bind:value="{landSelectionValue}"
                                            items="{landSelections}"
                                            focused="{false}"
                                            inputAttributes="{{ autocomplete: 'off' }}"
                                            placeholder=""
                                            id="country-{cartId}"
                                            clearable="{false}"
                                            disabled="{readonly}"
                                            on:change="{(e) => (formData.location.country = e.detail.value)}"
                                        />
                                    </div>
                                </div>
                            {/if}
                        </div>
                        {#if onlyBillingFields && showTelephoneNumber}
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.phone")}{noMandatoryMarkers ? "" : "*"}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            value="{formData?.contact?.phone || ''}"
                                            data-cy="tel"
                                            maxlength="{15}"
                                            id="phone-{cartId}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.contact.phone = e.target.value
                                            }}"
                                            required="{!readonly}"
                                        />
                                    </div>
                                </div>
                            </div>
                        {/if}
                        {#if onlyBillingFields && showPaymentTerms}
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.paymentTerms")}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            value="{formData?.company?.paymentTerms || ''}"
                                            id="paymentTerms-{cartId}"
                                            on:blur="{(e) => {
                                                if (!formData.company) formData.company = { name: "" }
                                                // @ts-ignore
                                                formData.company.paymentTerms = e.target.value
                                            }}"
                                            required="{false}"
                                        />
                                    </div>
                                </div>
                            </div>
                        {/if}
                        {#if !onlyBillingFields}
                            <div class="row">
                                <div class="col-md-{onlyDeliveryFields ? 4 : 3} col-sm-6">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.phone")}{noMandatoryMarkers ? "" : "*"}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            value="{formData?.contact?.phone || ''}"
                                            data-cy="tel"
                                            maxlength="{15}"
                                            id="phone-{cartId}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.contact.phone = e.target.value
                                            }}"
                                            required="{!readonly}"
                                        />
                                    </div>
                                </div>

                                <div class="col-md-{onlyDeliveryFields ? 4 : 3} col-sm-6">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.fax")}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            maxlength="{15}"
                                            id="fax-{cartId}"
                                            data-cy="fax"
                                            value="{formData?.contact?.fax || ''}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.contact.fax = e.target.value
                                            }}"
                                        />
                                    </div>
                                </div>

                                <div class="col-md-{onlyDeliveryFields ? 4 : 3} col-sm-6">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.email")}</label>
                                        <input
                                            type="email"
                                            placeholder=""
                                            id="email-{cartId}"
                                            data-cy="email"
                                            value="{formData?.contact?.email || ''}"
                                            maxlength="{56}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.contact.email = e.target.value
                                            }}"
                                        />
                                    </div>
                                </div>
                                {#if !onlyDeliveryFields && !onlyBillingFields}
                                    <div class="col-md-3 col-sm-6">
                                        <div class="inputholder haslabel" class:readonly>
                                            <label for="">, {$_("address.website")}</label>
                                            <input
                                                type="url"
                                                placeholder=""
                                                id="website-{cartId}"
                                                data-cy="website"
                                                value="{formData?.contact?.website || ''}"
                                                on:blur="{(e) => {
                                                    // @ts-ignore
                                                    formData.contact.website = e.target.value
                                                }}"
                                            />
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        {/if}
                        {#if !onlyDeliveryFields && formData.type === "company"}
                            <div class="row">
                                {#if !onlyBillingFields}
                                    <div class="col-md-6">
                                        <div class="inputholder haslabel" class:readonly>
                                            <label for="">{$_("address.customerNumber")}</label>
                                            <input
                                                type="text"
                                                placeholder=""
                                                id="customerNumber-{cartId}"
                                                data-cy="customerNumber"
                                                value="{formData?.customerNumber || ''}"
                                                on:blur="{(e) => {
                                                    // @ts-ignore
                                                    formData.customerNumber = e.target.value
                                                }}"
                                            />
                                        </div>
                                    </div>
                                {/if}
                                {#if !onlyBillingFields}
                                    <div class="col-md-6">
                                        <div class="inputholder haslabel" class:readonly>
                                            <label for="">{$_("address.paymentTerms").toUpperCase()}</label>
                                            <input
                                                type="text"
                                                placeholder=""
                                                id="paymentTerms-{cartId}"
                                                data-cy="paymentTerms"
                                                value="{formData?.company?.paymentTerms || ''}"
                                                on:blur="{(e) => {
                                                    // @ts-ignore
                                                    formData.company.paymentTerms = e.target.value
                                                }}"
                                            />
                                        </div>
                                    </div>{/if}
                            </div>
                        {/if}
                    </section>
                {/if}

                {#if (formData.type !== "person" && !onlyBillingFields) || onlyDeliveryFields == true}
                    <div>
                        {#if location.pathname.includes("addresses")}
                            <div class="row" data-cy="billing-address-row">
                                <div class="col-md-6">
                                    <div style="width: fit-content;">
                                        <Radiobutton
                                            label="{$_('address.deliveryEqualsCompany')}"
                                            checked="{formData?.deliveryAddress === null}"
                                            on:checked="{() => {
                                                formData.deliveryAddress = null
                                            }}"
                                            on:unchecked="{() => {
                                                formData.deliveryAddress = JSON.parse(
                                                    JSON.stringify(emptyDeliveryAddress)
                                                )
                                            }}"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div style="width: fit-content;">
                                        <Radiobutton
                                            label="{$_('address.deliveryUnequalsCompany')}"
                                            checked="{!!formData?.deliveryAddress}"
                                            on:checked="{() => {
                                                formData.deliveryAddress = JSON.parse(
                                                    JSON.stringify(emptyDeliveryAddress)
                                                )
                                            }}"
                                            on:unchecked="{() => {
                                                formData.deliveryAddress = null
                                            }}"
                                        />
                                    </div>
                                </div>
                            </div>
                        {/if}

                        {#if !!formData?.deliveryAddress}
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">
                                            {$_("address.companyName").toUpperCase()}{noMandatoryMarkers
                                                ? ""
                                                : "*"}</label
                                        >
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="companyname-billing-{cartId}"
                                            maxlength="{30}"
                                            data-cy="companyname-billing"
                                            value="{formData?.deliveryAddress?.name1 || ''}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.deliveryAddress.name1 = e.target.value
                                            }}"
                                            required="{!readonly}"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div
                                        class="inputholder haslabel"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for=""> {$_("address.company2OrAdditionalAddress").toUpperCase()}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="supplement-{cartId}"
                                            maxlength="{30}"
                                            data-cy="addresssup-billing"
                                            value="{formData?.deliveryAddress?.name2 || ''}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.deliveryAddress.name2 = e.target.value
                                            }}"
                                        />
                                    </div>
                                </div>
                                {#if window.location.pathname.includes("cart")}
                                    <div
                                        class="col-sm-12 col-md-4"
                                        class:hasNoValue="{!selectedSalutationItemDeliveryAddress?.value}"
                                    >
                                        <div class="inputholder haslabel" data-cy="salutation-billing" class:readonly>
                                            <label for="">{$_("address.contactPersonSalutation")} </label>
                                            <Select
                                                clearable="{true}"
                                                showChevron
                                                placeholder=""
                                                items="{salutationItems}"
                                                focused="{false}"
                                                bind:value="{selectedSalutationItemDeliveryAddress}"
                                                bind:disabled="{readonly}"
                                                on:clear="{() => {
                                                    selectedSalutationItemDeliveryAddress = {
                                                        label: '',
                                                        value: '',
                                                    }
                                                    formData.deliveryAddress.salutation = ''
                                                }}"
                                                on:change="{(e) => {
                                                    formData.deliveryAddress.salutation = e.detail.value
                                                }}"
                                            >
                                                <div slot="clear-icon">
                                                    {#if selectedSalutationItemDeliveryAddress?.value}
                                                        <Icon path="{mdiClose}" size="24px" />
                                                    {/if}
                                                </div>
                                            </Select>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 col-md-{onlyBillingFields ? 6 : 8}">
                                        <div class="inputholder haslabel" class:readonly>
                                            <label for="">{$_("address.contactPersonName")} </label>
                                            <input
                                                type="text"
                                                id="firstname-billing-{cartId}"
                                                data-cy="firstname-billing"
                                                placeholder=""
                                                maxlength="{30}"
                                                value="{formData?.deliveryAddress?.name3 || ''}"
                                                on:blur="{(e) => {
                                                    // @ts-ignore
                                                    formData.deliveryAddress.name3 = e.target.value
                                                }}"
                                                {readonly}
                                                disabled="{readonly}"
                                            />
                                        </div>
                                    </div>
                                {/if}
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div
                                        class="inputholder haslabel"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for=""
                                            >{$_("address.street")?.toUpperCase()}{noMandatoryMarkers ? "" : "*"}</label
                                        >
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="street-billing-{cartId}"
                                            data-cy="street-billing"
                                            value="{formData?.deliveryAddress?.street || ''}"
                                            maxlength="{28}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.deliveryAddress.street = e.target.value
                                            }}"
                                            required="{!readonly}"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 col-md-4">
                                    <div
                                        class="inputholder haslabel"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for=""
                                            >{$_("address.postcode").toUpperCase()}{noMandatoryMarkers
                                                ? ""
                                                : "*"}</label
                                        >
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="postcode-billing-{cartId}"
                                            data-cy="postcode-billing"
                                            value="{formData?.deliveryAddress?.postcode || ''}"
                                            maxlength="{10}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.deliveryAddress.postcode = e.target.value
                                            }}"
                                            required="{!readonly}"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-6 col-md-4">
                                    <div
                                        class="inputholder haslabel"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for=""
                                            >{$_("address.city").toUpperCase()}{noMandatoryMarkers ? "" : "*"}</label
                                        >
                                        <input
                                            type="text"
                                            placeholder=""
                                            id="city-billing-{cartId}"
                                            data-cy="city-billing"
                                            value="{formData?.deliveryAddress?.city || ''}"
                                            maxlength="{30}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.deliveryAddress.city = e.target.value
                                            }}"
                                            required="{!readonly}"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <div
                                        class="inputholder haslabel"
                                        data-cy="country-billing"
                                        class:readonly="{readonly ? true : false || disableCompanyFields}"
                                    >
                                        <label for="">{$_("address.country").toUpperCase()}</label>
                                        <Select
                                            bind:value="{landSelectionValueDeliveryAddress}"
                                            items="{landSelections}"
                                            focused="{false}"
                                            inputAttributes="{{ autocomplete: 'off' }}"
                                            placeholder=""
                                            id="country-billing-{cartId}"
                                            clearable="{false}"
                                            disabled="{readonly}"
                                            on:change="{(e) => (formData.deliveryAddress.country = e.detail.value)}"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">
                                            {$_("address.phone").toUpperCase()}{noMandatoryMarkers ? "" : "*"}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            value="{formData?.deliveryAddress?.phone || ''}"
                                            data-cy="tel-billing"
                                            maxlength="{15}"
                                            id="phone-billing-{cartId}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.deliveryAddress.phone = e.target.value
                                            }}"
                                            required="{!readonly}"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.fax").toUpperCase()}</label>
                                        <input
                                            type="text"
                                            placeholder=""
                                            maxlength="{15}"
                                            id="fax-billing-{cartId}"
                                            data-cy="fax-billing"
                                            value="{formData?.deliveryAddress?.fax || ''}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.deliveryAddress.fax = e.target.value
                                            }}"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="inputholder haslabel" class:readonly>
                                        <label for="">{$_("address.email").toUpperCase()}</label>
                                        <input
                                            type="email"
                                            placeholder=""
                                            id="email-billing-{cartId}"
                                            data-cy="email-billing"
                                            value="{formData?.deliveryAddress?.email || ''}"
                                            maxlength="{56}"
                                            on:blur="{(e) => {
                                                // @ts-ignore
                                                formData.contact.email = e.target.value
                                            }}"
                                        />
                                    </div>
                                </div>
                            </div>
                        {/if}
                    </div>
                {/if}
            </div>
            {#if formData.type == "company"}
                {#if showPriceCalcSelect}
                    <div class="row">
                        <div class="{'col-md-12'}">
                            <h4>{$_("address.assignedPriceGroup")}</h4>
                            <div
                                class="inputholder haslabel"
                                data-cy="pricegroup-select"
                                class:readonly="{readonly
                                    ? true
                                    : false || disableCompanyFields || formData.notModifyablePCalc}"
                            >
                                <Select
                                    items="{priceGroupItems}"
                                    inputAttributes="{{ autocomplete: 'off' }}"
                                    placeholder=""
                                    showChevron="{true}"
                                    clearable="{!formData.notModifyablePCalc &&
                                    !disableCompanyFields &&
                                    priceCalcValue?.value
                                        ? true
                                        : false}"
                                    bind:value="{priceCalcValue}"
                                    on:clear="{() => {
                                        priceCalcValue = {
                                            label: '',
                                            value: null,
                                        }
                                        formData.priceCalculation = null
                                    }}"
                                />
                            </div>
                        </div>
                    </div>
                {/if}
                {#if priceCalcValue?.value == "manual" && location.pathname.includes("addresses")}
                    <div class="row pCalc pcalc">
                        <div class="{'col-md-12'}">
                            <PricecalcFields bind:priceCalculation="{formData.priceCalculationManual}" />
                        </div>
                    </div>
                {/if}{/if}
            <div class="layout justify-content-end layout-gap-md mt-md">
                <slot />
            </div>
        {/if}
    </form>
{/if}
